import { useEffect } from "react";

import { BRAND_CONFIGURATION } from "../../../../../configs/brands";
import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useOverlayStepsOrchestrator } from "../../useOverlayStepsOrchestrator";

const { qualtrics } = BRAND_CONFIGURATION;
const KEY = "qualtrics";

export const useInitQualtrics = () => {
  const { dispatch } = useOverlayOrchestrator();
  const canProceed = useOverlayStepsOrchestrator(KEY);

  useEffect(() => {
    if (!qualtrics) {
      dispatch({ type: "DISABLE", payload: KEY });

      return;
    }

    if (canProceed) {
      dispatch({ type: "INIT", payload: KEY });
    }
  }, [canProceed, dispatch]);
};
